



import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "demo",
  head: {
    meta: [
      //HIDING FROM SEARCH ENGINES
      { name: "robots", content: "noindex,nofollow" },
    ],
    script: [
      //HUBSPOT
      {
        type: "text/javascript",
        src: "//js.hs-scripts.com/3207818.js",
        id: "hs-script-loader",
        body: true,
      },
    ],
  },
})
export default class Demo extends Vue {}
